import { ifProp } from 'src/shared/styled-utils/ifProp';
import styled from 'styled-components';
import { buildBreakpoint } from './buildBreakpoint';
import { NumberAttr } from './types';

export interface ColProps {
  xs?: NumberAttr;
  sm?: NumberAttr;
  md?: NumberAttr;
  lg?: NumberAttr;
  noPadding?: boolean;
}

/**
 * Component for minimally replacing bootstrap column classes
 * @param {ColProps} props
 */
export const Col = styled.div<ColProps>`
  position: relative;
  min-height: 1px;
  padding: 0 ${ifProp('noPadding', '0', '15px')};

  float: left;

  ${({ xs }) => (xs ? buildBreakpoint(xs) : 'width: 100%;')}
  ${({ sm }) => sm && buildBreakpoint(sm, 768)}
  ${({ md }) => md && buildBreakpoint(md, 992)}
  ${({ lg }) => lg && buildBreakpoint(lg, 1200)}
`;

export { getWidth } from './getWidth';
export { buildBreakpoint };
export type { NumberAttr };
